import { CAST_AI } from '@cast/constants';
import { Icons, Typography, Box, Stack, tokens } from '@cast/design-system';

export const StorageOptimizationActiveBanner = () => (
  <Stack
    data-testid="storage-optimization-active-banner"
    direction="row"
    alignItems="flex-start"
    gap={8}
    sx={{
      p: 12,
      borderRadius: '6px',
      backgroundColor: 'green.50',
      border: '1px solid',
      borderColor: tokens.theme.border.status.successSubtle,
    }}
  >
    <Box sx={{ color: 'green.500', display: 'flex', flexShrink: 0, mt: 1 }}>
      <Icons.CheckCircle size={16} weight="fill" />
    </Box>
    <Stack>
      <Typography variant="P14M">
        Storage optimization is active on this node
      </Typography>
      <Typography variant="P14R" color="textSecondary">
        {CAST_AI} manages ephemeral storage on dedicated volumes instead of the
        root disk. IOPS and throughput scale automatically based on usage.
        Capacity expands before you run out of space.
      </Typography>
    </Stack>
  </Stack>
);
